import script from "./CategoryTreeInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryTreeInput.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryTreeInput.vue?vue&type=style&index=0&id=b3a6fbfe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3a6fbfe"]])

export default __exports__